import React from "react";

const Loading = (
  <div className="grid place-items-center h-screen">
    <img src="/logo.png" alt="logo" className="max-w-xs animate-pulse" />
  </div>
);

export default Loading;
